import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export default function MessageModerationPage() {
  return (
    <div data-testid="message-moderation-page" className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex items-center gap-3 mb-8">
        <Link to="/admin"><Button variant="ghost" size="sm" className="rounded-full"><ArrowLeft className="w-4 h-4" /></Button></Link>
        <div>
          <h1 className="text-3xl font-bold" style={{ fontFamily: 'Outfit, sans-serif' }}>Message Moderation</h1>
          <p className="text-slate-500 mt-1">Review reported messages and conversations</p>
        </div>
      </div>
      <div className="text-center py-20 text-slate-400">
        <p className="text-lg font-medium">Message moderation is managed through the Reports page</p>
        <p className="text-sm mt-1">When messages are reported, they appear in the reports section with details</p>
        <Link to="/admin/reports" className="mt-4 inline-block">
          <Button className="rounded-full bg-[#b456df] text-white hover:bg-[#9a3ec4]">View Reports</Button>
        </Link>
      </div>
    </div>
  );
}
